import FloatingLabelInput from './FloatingLabelInput';
import { AsYouType, parsePhoneNumberFromString, getCountryCallingCode, isSupportedCountry } from 'libphonenumber-js';
const {text} = window;

export default class PhoneNumberInput extends FloatingLabelInput {

    constructor({ className, id, label, type, allowAllCountries, allowedCountries}) {
        super(...arguments);

        if (!allowAllCountries && !allowedCountries){
            throw new Error('no allowed countries specified');
        }

        if (allowAllCountries){
            this.allowedCountries = this.allCountries;
        } else {
            this.allowedCountries = allowedCountries;
        }

        if (this.allowedCountries){
            this.selectedCountry = this.allowedCountries[0];
        }
        this.setupMenuWidget();
    }

    render(){
        super.render();

        this.$el.addClass('phoneNumberInput ui-front');
        if (this.showCountrySelector){
            this.$el.prepend(`
                <select class="phoneCountrySelector" aria-label="${text('idc.mobileNumberCountryLabel')}">
                    ${this.allowedCountries.map((x) => `<option value="${x}"> ${x} <img class="flagIcon" src="${window.OverDrive.cdn}/public/img/flags/${x}.svg"/></option>`).join('\n')}
                </select>`);
            this.$countrySelect = this.$el.find('.phoneCountrySelector');
            this.$countrySelect.countrySelectMenu({
                change: (evt, item) => {
                    this.country = item.item.value;
                },
                icons: {button: 'icon-down-arrow'}
            });
        }

        this._attachPhoneNumberEvents();
        return this;
    }

    setupMenuWidget() {
        $.widget('custom.countrySelectMenu', $.ui.selectmenu, {
            _renderItem: (ul, item) => {
                let val = item.element.val();
                let listItem = $(`<li>
                     <div>
                        <img class="flagIcon" src="${window.OverDrive.cdn}/public/img/flags/${val}.svg"/>
                        <span class="countryName">${text(`countryNames.${val.toUpperCase()}`)}</span>
                        <span class="countryCallingCode">+${getCountryCallingCode(val)}</span>
                </li>`);

                 ul.append(listItem);
                 return listItem;
            },
            _renderButtonItem(item){
                //
                let buttonItem = $(`
                    <div class="menuButtonWrapper"><img class="flagIcon" src='${window.OverDrive.cdn}/public/img/flags/${item.element.val()}.svg'/><i class='icon-down-arrow' aria-hidden='true'></i><div>`);
                return buttonItem;
            }
          });
    }

    set country(countryCode){
        this.selectedCountry = countryCode;
        this._formatNumber();
        this.clearInvalid();
    }

    get showCountrySelector(){
        return this.allowAllCountries || (this.allowedCountries.length > 1);
    }

    _formatNumber(){
        let current = this.$input.val();
        if (current){
            let formatted = new AsYouType(this.selectedCountry).input(current);
            this.$input.val(formatted);
        }
    }

    _attachPhoneNumberEvents(){
        this.$input.on('input', () => this._formatNumber());
        if (this.$countrySelect){
            this.$countrySelect.on('change', () => {
                this.country = this.$countrySelect.val();
            });
        }
        this.$input.on('keydown', (e) => this.onKeydown(e));
    }

    onKeydown(e){
        // We need special handing for backspace and delete because of the auto-formatting
        // behavior. Without this, it's impossible to backspace/delete past certain formatting characters
        // because the formatting keeps reinserting them.  User selected text can be handled normally.
        let noSelection = e.target.selectionStart === e.target.selectionEnd;
        if (noSelection && (e.keyCode === 8 || e.keyCode === 46)) {

            let digitsBeforeCursor = this.countPrecedingDigits(e.target.selectionStart);
            let digitsOnly = this.unformattedValue;
            let updated, newCursorPosition;
            if (e.keyCode === 8){  // BACKSPACE
                updated = digitsOnly.slice(0, digitsBeforeCursor - 1) + digitsOnly.slice(digitsBeforeCursor);
                newCursorPosition = digitsBeforeCursor;
            } else if (e.keyCode === 46){  // DELETE
                updated = digitsOnly.slice(0, digitsBeforeCursor) + digitsOnly.slice(digitsBeforeCursor + 1);
                newCursorPosition = digitsBeforeCursor + 1;
            }

            this.$input.val(updated);
            this._formatNumber();
            this.repositionCursor(newCursorPosition);
            e.preventDefault();
        }
    }

    // Reposition the cursor following the nth numeric character in the formatted string
    repositionCursor(digitIndex){
        let val = this.$input.val();
        let i = 0;
        let digitsFound = 0;
        for (; i < val.length; ++i) {
            if (digitsFound === digitIndex - 1){
                break;
            }
            let char = val.charAt(i);
            if (this.isDigit(char)){
                digitsFound++;
            }
        }
        this.$input[0].setSelectionRange(i,i);
    }

    isDigit(c){
        return (/^\d$/).test(c);
    }

    countPrecedingDigits(index){
        return this.$input.val().slice(0, index).split('').filter((c) => this.isDigit(c)).length;
    }

    countFollowingDigits(index){
        return this.$input.val().slice(index).split('').filter((c) => this.isDigit(c)).length;
    }

    get unformattedValue(){
        return this.$input.val().split('').filter((c) => this.isDigit(c)).join('');
    }

    validate(){
        let number = parsePhoneNumberFromString(this.$input.val(), this.selectedCountry);
        if (!number || !number.isValid()){
            this.displayInvalid();
            return false;
        }
        return true;
    }

    displayInvalid() {
        if (!this.invalid){
            super.displayInvalid();
            this.$el.addClass('invalid');
            this.invalid = true;
        }
    }

    clearInvalid(){
        if (this.invalid){
            super.clearInvalid();
            this.$el.removeClass('invalid');
            this.invalid = false;
        }
    }


    floatLabel(){
        super.floatLabel();
        this.$el.addClass('focused');

    }

    sinkLabel(){
        super.sinkLabel();
        this.$el.removeClass('focused');
    }

    get E164(){
        let parsed = parsePhoneNumberFromString(this.$input.val(), this.selectedCountry);
        return parsed ? parsed.number : parsed;
    }

    get displayValue(){
        return this.$input.val();
    }

    get allCountries() {
        return ['AF','AX','AL','DZ','AS','AD','AO','AI','AG','AR','AM','AW','AU','AT','AZ','BS','BH','BD','BB','BY','BE','BZ','BJ','BM','BT','BO','BA','BW','BR','IO','VG','BN','BG','BF','BI','KH','CM','CA','IC','CV','BQ','KY','CF','EA','TD','CL','CN','CX','CC','CO','KM','CG','CD','CK','CR','CI','HR','CU','CW','CY','CZ','DK','DG','DJ','DM','DO','EC','EG','SV','GQ','ER','EE','SZ','ET','FK','FO','FJ','FI','FR','GF','PF','TF','GA','GM','GE','DE','GH','GI','GR','GL','GD','GP','GU','GT','GG','GN','GW','GY','HT','HN','HK','HU','IS','IN','ID','IR','IQ','IE','IM','IL','IT','JM','JP','JE','JO','KZ','KE','KI','XK','KW','KG','LA','LV','LB','LS','LR','LY','LI','LT','LU','MO','MG','MW','MY','MV','ML','MT','MH','MQ','MR','MU','YT','MX','FM','MD','MC','MN','ME','MS','MA','MZ','MM','NA','NR','NP','NL','NC','NZ','NI','NE','NG','NU','NF','KP','MK','MP','NO','OM','PK','PW','PS','PA','PG','PY','PE','PH','PN','PL','PT','XA','XB','PR','QA','RE','RO','RU','RW','WS','SM','ST','SA','SN','RS','SC','SL','SG','SX','SK','SI','SB','SO','ZA','GS','KR','SS','ES','LK','BL','SH','KN','LC','MF','PM','VC','SD','SR','SJ','SE','CH','SY','TW','TJ','TZ','TH','TL','TG','TK','TO','TT','TN','TR','TM','TC','TV','UM','VI','UG','UA','AE','GB','US','UY','UZ','VU','VA','VE','VN','WF','EH','YE','ZM','ZW']
            .filter((x) => isSupportedCountry(x));
    }
}
